var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowMachineMultiLeftToRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109.36,
    height: 131.789,
    viewBox: "316.893 1446.308 27.34 32.947",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 834"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 833",
    transform: "translate(305.417 1446.309)",
    clipPath: "url(\"#a\")"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "ArrowIcon2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 832"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 831"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Arrow",
    clipPath: "url(\"#b\")"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 316",
    fill: "#040000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.647 15.975L26.455.282a.694.694 0 00-1.022-.105.799.799 0 00-.264.603v31.386c-.002.429.321.779.723.78a.709.709 0 00.563-.282l12.192-15.692a.821.821 0 000-.997",
    "data-name": "\\u30D1\\u30B9 336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.476 9.61h14.205v13.727H11.476V9.609z",
    "data-name": "\\u9577\\u65B9\\u5F62 400"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrowMachineMultiLeftToRight_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h38.821v32.946H0V0z",
    "data-name": "\\u9577\\u65B9\\u5F62 472"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "arrowMachineMultiLeftToRight_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h38.821v32.946H0V0z",
    "data-name": "\\u9577\\u65B9\\u5F62 473"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMachineMultiLeftToRight);
export default __webpack_public_path__ + "static/media/arrowMachineMultiLeftToRight.7348646dab13837d.svg";
export { ForwardRef as ReactComponent };